import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path } from "react-native-svg";

export default function TeamIcon(props) {

  return (
    <TouchableOpacity {...props}>
      <Svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M3.75 5.9375C4.95812 5.9375 5.9375 4.95812 5.9375 3.75C5.9375 2.54188 4.95812 1.5625 3.75 1.5625C2.54188 1.5625 1.5625 2.54188 1.5625 3.75C1.5625 4.95812 2.54188 5.9375 3.75 5.9375Z"
          fill="white"
        />
        <Path
          d="M5.3125 14.0625V10C5.3125 9.07094 5.68438 8.22813 6.28562 7.60906C5.92406 7.34531 5.48063 7.1875 5 7.1875H2.5C1.29375 7.1875 0.3125 8.16875 0.3125 9.375V11.875C0.3125 11.9934 0.379375 12.1016 0.485312 12.1547L1.57594 12.7L1.87562 16.8975C1.8875 17.0609 2.02375 17.1875 2.1875 17.1875H5.3125C5.47625 17.1875 5.6125 17.0609 5.62437 16.8972L5.76937 14.8666C5.49312 14.7006 5.3125 14.3987 5.3125 14.0625Z"
          fill="white"
        />
        <Path
          d="M16.25 5.9375C17.4581 5.9375 18.4375 4.95812 18.4375 3.75C18.4375 2.54188 17.4581 1.5625 16.25 1.5625C15.0419 1.5625 14.0625 2.54188 14.0625 3.75C14.0625 4.95812 15.0419 5.9375 16.25 5.9375Z"
          fill="white"
        />
        <Path
          d="M14.6875 14.0625V10C14.6875 9.07094 14.3156 8.22813 13.7144 7.60906C14.0759 7.34531 14.5194 7.1875 15 7.1875H17.5C18.7062 7.1875 19.6875 8.16875 19.6875 9.375V11.875C19.6875 11.9934 19.6206 12.1016 19.5147 12.1547L18.424 12.7L18.1244 16.8975C18.1125 17.0609 17.9762 17.1875 17.8125 17.1875H14.6875C14.5237 17.1875 14.3875 17.0609 14.3756 16.8972L14.2306 14.8666C14.5069 14.7006 14.6875 14.3987 14.6875 14.0625Z"
          fill="white"
        />
        <Path
          d="M11.25 7.1875H8.75C7.19938 7.1875 5.9375 8.44938 5.9375 10V14.0625C5.9375 14.2116 6.0425 14.3397 6.18875 14.3687L7.51562 14.6341L7.81313 19.3944C7.82344 19.5591 7.96 19.6875 8.125 19.6875H11.875C12.04 19.6875 12.1766 19.5591 12.1869 19.3944L12.4844 14.6344L13.8112 14.3691C13.9575 14.3397 14.0625 14.2116 14.0625 14.0625V10C14.0625 8.44938 12.8006 7.1875 11.25 7.1875Z"
          fill="white"
        />
        <Path
          d="M10 5.9375C11.5506 5.9375 12.8125 4.67562 12.8125 3.125C12.8125 1.57438 11.5506 0.3125 10 0.3125C8.44938 0.3125 7.1875 1.57438 7.1875 3.125C7.1875 4.67562 8.44938 5.9375 10 5.9375Z"
          fill="white"
        />
      </Svg>
    </TouchableOpacity>
  );
}
